import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Comment } from '../../types/comment';
import { User } from '@ml/core/types/classes/user.class';

@Component({
  selector: 'ml-comments-list',
  template: `
    <h3
      class="mat-title comments-title"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      {{ 'comments' | translate | titlecase }}
    </h3>
    <div *ngIf="!loading; else loadingComments">
      <div
        class="full-width"
        fxLayout="column"
        *ngIf="comments?.length; else noComments"
      >
        <ml-comment
          [comment]="comment"
          [currentUser]="currentUser"
          (delete)="deleteComment.emit($event)"
          *ngFor="let comment of comments; let last = last"
        >
          <mat-divider class="divider" *ngIf="!last"></mat-divider>
        </ml-comment>
        <div
          class="full-width load-more"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <button
            mat-button
            [disabled]="!next || loadingMore"
            color="primary"
            class="comments__load-more-button"
            (click)="onLoadMore()"
          >
            <div *ngIf="!loadingMore; else loadingMoreComments">
              {{ 'load more' | translate | sentancecase }}
            </div>
            <ng-template #loadingMoreComments>
              <mat-spinner
                [diameter]="24"
                color="primary"
                style="margin: auto"
              ></mat-spinner>
            </ng-template>
          </button>
        </div>
      </div>
      <ng-template #noComments>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="mat-subheading-1"
        >
          {{ 'there-are-no' | translate | sentancecase }}
          {{ 'comments' | translate }} !
        </div>
      </ng-template>
    </div>
    <ng-template #loadingComments>
      <mat-spinner color="primary" style="margin: auto"></mat-spinner>
    </ng-template>
  `,
  styleUrls: ['./comments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsListComponent implements OnInit {
  @Input() comments: Comment[];
  @Input() currentUser: User;
  @Input() loadingMore: boolean;
  @Input() loading: boolean;
  @Input() next: boolean;
  @Output() loadMore = new EventEmitter();
  @Output() deleteComment = new EventEmitter<Comment>();
  constructor() {}

  ngOnInit() {}

  onLoadMore() {
    this.loadMore.emit();
  }
}
